import type { RootState } from '@/store/store';

export const selectGlobalLoading = (state: RootState) => state.ui.globalLoading;
export const selectGlobalError = (state: RootState) => state.ui.globalError;
export const selectSidebarCollapsed = (state: RootState) => state.ui.sidebarCollapsed;
